// Storage key for the bookabus-price checkout, kept in its own module with no imports of its
// own: both the wizard state hook and auth.service (which clears the checkout on logout) need
// it, and importing it from the hook would put those two modules in an import cycle.
export const BOOKABUS_PRICE_CHECKOUT_STORAGE_KEY = "bookabusPriceWizardState";

/**
 * Forget the stored checkout.
 *
 * Used when a checkout is over rather than interrupted: the customer has sent their quote
 * request, or has logged out. A checkout that is merely interrupted - a reload, a new tab, a
 * round trip through an email client - is meant to survive, so this is deliberately not called
 * on those paths.
 *
 * Guarded the same way writing it is, since private browsing can refuse storage outright.
 */
export const clearBookabusPriceCheckout = () => {
    try {
        localStorage.removeItem(BOOKABUS_PRICE_CHECKOUT_STORAGE_KEY);
    } catch {
        // Nothing to clear if storage is unavailable.
    }
};
